define('core/linter-rules/check-punctuation',["exports", "core/l10n", "core/LinterRule"], function (exports, _l10n, _LinterRule) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.rule = undefined;

  var _LinterRule2 = _interopRequireDefault(_LinterRule);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  const name = "check-punctuation";
  const punctuationMarks = [".", ":", "!", "?"];
  const humanMarks = punctuationMarks.map(mark => `"${mark}"`).join(", ");
  const meta = {
    en: {
      description: "`p` elements should end with a punctuation mark.",
      howToFix: `Please make sure \`p\` elements end with one of: ${humanMarks}.`
    }
  };
  // Fall back to english, if language is missing
  const lang = _l10n.lang in meta ? _l10n.lang : "en";

  /**
   * Runs linter rule.
   *
   * @param {Object} config The ReSpec config.
   * @param  {Document} doc The document to be checked.
   */
  function lintingFunction(conf, doc) {
    // Check string ends with one of ., !, ?, :, ], or is empty.
    const punctuatingRegExp = new RegExp(`[${punctuationMarks.join("")}\\]]$|^ *$`, "m");
    const offendingElements = [...doc.querySelectorAll("p:not(#back-to-top)")].filter(elem => !punctuatingRegExp.test(elem.textContent.trim()));
    if (!offendingElements.length) {
      return [];
    }
    const result = _extends({
      name,
      offendingElements,
      occurrences: offendingElements.length
    }, meta[lang]);
    return result;
  }
  const rule = exports.rule = new _LinterRule2.default(name, lintingFunction);
});
//# sourceMappingURL=check-punctuation.js.map;
